export function lightboxOpen(photoList, photoIndex) {
  return {
    type: "LIGHTBOX_OPEN",
    payload: {
      photoList: photoList,
      photoIndex: photoIndex,
    }
	}
}

export function lightboxClose() {
  return {
    type: "LIGHTBOX_CLOSE",
	}
}

export function lightboxNext() {
  return {
    type: "LIGHTBOX_NEXT",
	}
}

export function lightboxPrev() {
  return {
    type: "LIGHTBOX_PREV",
	}
}
